/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'subnav': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="matrix(-1 0 0 1 25 10)" _stroke="#FFF" stroke-width=".8"><path pid="0" d="M19 0v5c0 2.761-2.278 5-5.087 5H1"/><polyline pid="1" points="4 14 0 10 4 6"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/subnav.js